import { WhitelistTab } from './SettingsPage';
import styles from './SettingsPage.module.scss';

export function WhitelistPage() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h1 className={styles.title}>Whitelist</h1>
          <p className={styles.subtitle}>Gérez les joueurs autorisés à se connecter</p>
        </div>
      </header>

      <div className={styles.content}>
        <WhitelistTab />
      </div>
    </div>
  );
}
